import { useState } from 'react';

import constate from 'constate';

type FormDatas = {
    provider: string | undefined;
    preferredProvider: string | undefined;
    currentOffer: string | undefined;
    reason: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    phone: string | undefined;
    consentement: boolean | undefined;
    favoris: any;
    usage: any;
};

const useFormStoreDatas = () => {
  const [formDatas, setFormDatas] = useState<FormDatas>({
    provider: undefined,
    preferredProvider: undefined,
    currentOffer: undefined,
    reason: undefined,
    firstname: undefined,
    lastname: undefined,
    phone: undefined,
    consentement: undefined,
    favoris: undefined,
    usage: undefined,
  });

  return { formDatas, setFormDatas };
};

const [FormStoreDatasProvider, useFormStoreDatasContext] = constate(useFormStoreDatas);

export { FormStoreDatasProvider, useFormStoreDatasContext };
